// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2751e7a4","453":"0eee7315","455":"2eb79059"}[chunkId] + ".chunk.js";
};